import React, { useState, useEffect } from "react";
import enUS from "../../../data/en-US";
import { useLanguageContext } from "../../../context/languageContext";
import { fakedb } from "../../../data/fakedb";
import Card05 from "../../cards/Card05";
import Button from "../../buttons/Button";

const EventSection = () => {
    const { language } = useLanguageContext();
    const [ data, setData ] = useState();
    const info = {
        'en-US': enUS
    }
    useEffect(() => {
        setData(info[language].homepage.events)
    })

    return (
        <div className="news-section-wrapper font-face-poppins">
            <div className="themesflat-container">
                <div className="news-section-title font-face-pop text-center">
                    { data && data.heading}
                </div>
                <div className="news-section-body text-center">
                    { data && data.body}
                </div>
                <div className="news-section-show">
                    <div className="row">
                        <div className="col-md-6">
                            <Card05 item={fakedb.events_top_5[0]} />
                        </div>
                        <div className="col-md-6 flex flex-col justify-between">
                            <Card05 item={fakedb.events_top_5[1]} />
                            <Card05 item={fakedb.events_top_5[2]} />
                        </div>
                    </div>
                    <div className="row mt-5">
                        <div className="col-md-6">
                            <Card05 item={fakedb.events_top_5[3]} />
                        </div>
                        <div className="col-md-6">
                            <Card05 item={fakedb.events_top_5[4]} />
                        </div>
                    </div>
                </div>
                <div className="news-section-footer text-right">
                    <Button
                        width={276}
                        height={48}
                        text={ data && data.footer.button }
                        borderRadius="9"
                        fontSize="1.2em"
                    />
                </div>
            </div>
        </div>
    )
}

export default EventSection;